import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import { axiosClient, queryClient } from "../../clients";

import type { IMemberResearchProjects } from "./routeType";

import type { IPickDelete } from "@/api";
import { getApi } from "@api/apiPath";
import { useGetAllMemberResearchProjects } from "@/api/members/researchProjects/getAll";
import { useGetMemberResearchProject } from "@/api/members/researchProjects/get";

const { getPath } = getApi("members.researchProject.delete");

type IExtractedRouteType =
  IMemberResearchProjects["researchProjectSingleDelete"];

export type IDeleteMemberResearchProject = IPickDelete<IExtractedRouteType>;

const deleteMemberResearchProject: MutationFunction<
  IDeleteMemberResearchProject["response"],
  IDeleteMemberResearchProject["variables"]
> = ({ memberId, projectId }) => {
  return axiosClient.delete(getPath({ memberId, projectId }));
};

export const useDeleteMemberResearchProject = createMutation({
  mutationFn: deleteMemberResearchProject,
  onSuccess: (_, { memberId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberResearchProjects.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberResearchProject.getKey({ memberId }),
    });
  },
});
